import React, {useState, useEffect} from 'react'
import {Grid} from '@mui/material'
import SelectInput from '../../SelectInput'
import {getMonthSelectorOptions} from '../residentSentimentUtilities'
import MetricDataAPI from '../../../lib/MetricData/MetricDataAPI'
import {useSelector} from 'react-redux'
import DetailItemsList from './DetailItemsList'
import LoadingStateIconAndMessage from '../../LoadingStateIconAndMessage'
import EmptyStateIconAndMessage from '../../EmptyStateIconAndMessage'
import RXRIcon from '../../RXRIcon'
import {makeStyles} from '@mui/styles'
import {valueToFixed} from '../utils'
import {Spacing, Typography} from '../../../assets/styles'

const dateOptions = getMonthSelectorOptions()

function OnboardingRatingDetails(props) {
  const isMobile = useSelector(state => state.App.isMobile)
  const classes = useStyles({isMobile})
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  /** @type {FeedbackDetailsPayload} data */
  const [asOfDate, setAsOfDate] = useState(dateOptions[0].value)
  const activeBuildingId = useSelector(state => state.Buildings.activeBuildingId)
  const buildingsLookup = useSelector(state => state.Buildings.buildingsLookup)
  const activeBuildingYardiId = buildingsLookup[activeBuildingId]?.yardiId
  const [items, setItems] = useState([])

  // Convert filtered items into an aggregate count called itemsCount and
  // an average score which is an average of the rating for each filteredItem
  const itemsCount = items.length
  const totalScore = items.reduce((acc, item) => {
    return acc + item.value
  }, 0)
  const averageScore = itemsCount > 0 ? totalScore / itemsCount : 'N/A'

  useEffect(() => {
    setIsLoading(true)
    MetricDataAPI.fetchFeedbackCategoryDetails(activeBuildingYardiId, asOfDate, ['ONBOARDING'])
      .then(r => {
        setItems(r.items || [])
      })
      .catch(setError)
      .finally(() => {
        setIsLoading(false)
      })
  }, [activeBuildingId, asOfDate])

  return (
    <div className={classes.onboardingRatingDetailsContainer}>
      <Grid container spacing={3}>
        <Grid item xs={7} sm={12} md={4}>
          <SelectInput onChange={setAsOfDate} value={asOfDate} label={''} options={dateOptions} />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          {isLoading ? (
            <LoadingStateIconAndMessage message={'Loading details'} />
          ) : error ? (
            <EmptyStateIconAndMessage message={error} icon={RXRIcon.ERROR} />
          ) : !items || items.length === 0 ? (
            <EmptyStateIconAndMessage message={'No details to show'} icon={RXRIcon.ELLIPSIS} />
          ) : (
            <>
              <div className={classes.aggregatedMetrics}>
                {itemsCount} Comments, Average score: {valueToFixed(averageScore)}
              </div>
              <DetailItemsList items={items} noDescriptionText={'Resident has not left a comment.'} />
            </>
          )}
        </Grid>
      </Grid>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  aggregatedMetrics: {
    fontSize: Typography.fontSizeMediumLarge,
    fontWeight: Typography.heavyFontWeight,
    paddingTop: Spacing.spaceExtraSmall,
    paddingBottom: Spacing.spaceSmall,
  },
  onboardingRatingDetailsContainer: props => ({
    width: props.isMobile ? '180%' : undefined,
  }),
}))

export default OnboardingRatingDetails
